// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"948c745a","457":"1678e26f","551":"24b5368d","851":"ded539f4"}[chunkId] + ".chunk.js";
};